import {Core} from '@strapi/strapi';
import _ from 'lodash';

const TEMPLATE_UID = 'plugin::telegram-bot.bot-message-template';

export interface TemplateConfig {
  type: string,
  input: string,
  params?: unknown
}

export interface TemplateConfig {
  type: string,
  input: string,
  params?: unknown
}

const BotMessageTemplate = ({strapi}: { strapi: Core.Strapi }) => ({
  cache: {} as Record<string, TemplateConfig>,
  async renewCache(){
    //Todo: Renew cache should work in multiple instances mode
    const message = await strapi.db.query(TEMPLATE_UID).findOne();

    if (!message) {
      this.cache = {};
      return;
    }

    const data = _.cloneDeep(message as Record<string, string>)

    const newCache = {};
    // Auto escape dot character
    Object.entries(data).forEach(([key, value]) => {
      if (['id', 'documentId', 'locale', 'publishedAt', 'updatedAt', 'createdAt'].indexOf(key) > -1) return;
      newCache[key] = value;
    });

    this.cache = newCache;
  },

  getMessage(key: string, defaultConfig: TemplateConfig) {
    return this.cache[key]?.input ? this.cache[key] : defaultConfig;
  },

  getHelpMessage() {
    return this.getMessage('help_message', {
      'type': 'reply',
      'input': 'Help message'
    });
  },

  getAutoAnswerMessage() {
    return this.getMessage('auto_answer_message', {
      'type': 'reply',
      'input': 'Auto answer message'
    });
  },

  getWelcomeMessage() {
    return this.getMessage('welcome_message', {
      'type': 'reply',
      'input': `Welcome to Telegram Bot:
Some basic commands:
- /start: Shows start
- /help: Show help`
    });
  },
});

export type BotMessageTemplateType = ReturnType<typeof BotMessageTemplate>;
export default BotMessageTemplate;
